export const convertToAmPmFormat = timeString => {
  const [hours, minutes] = timeString.split(':').map(Number);
  const period = hours >= 12 ? 'pm' : 'am';
  const hours12 = hours % 12 || 12;
  const formattedTime = `${hours12}${minutes !== 0 ? `:${minutes}` : ''}${period}`;

  return formattedTime;
};
